module.exports = __webpack_public_path__ + "static/img/robot.e06891c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/robot.gif
// module id = BaWn
// module chunks = 15